import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { getListingUrl } from "../../../utils/url.utils";

const CollectionGrid = ({ collections = [], loading }) => {
    if (loading) {
        return (
            <main className="products-grid">
                {Array.from({ length: 8 }).map((_, i) => (
                    <Skeleton key={i} height={180} />
                ))}
            </main>
        );
    }

    // Pattern: 3 normal + 1 full (repeat)
    const getClassByIndex = (index) => {
        return (index + 1) % 4 === 0 ? "full" : "normal";
    };

    return (
        <main className="products-grid">
            {collections?.map((item, i) => (
                <div
                    key={item?.id || i}
                    className={`product-card ${getClassByIndex(i)}`}
                >
                    <Link to={getListingUrl(item?.action_url)}>
                        <img
                            src={item?.uploaded_media}
                            alt={item?.name}
                            effect="blur"
                            width="100%"
                            height="100%"
                        />
                        <p className="title">{item?.name}</p>
                    </Link>
                </div>
            ))}
        </main>
    );
};

export default CollectionGrid;